/** Stripe Publishable Keys */
const PROD_STRIPE_PUBLISHABLE_KEY =
  "pk_live_51RKNIYRo5rtjEMiwJmiXuTxjRsLL3egH2oCgaiNNtSF5t1zlqFylAlGVvPQJaYO9P6SbRICFn0iczqMc2nHqrH5m00NbLvHnwP";

const DEV_STRIPE_PUBLISHABLE_KEY =
  "pk_test_51Snn3wRojWIVDFbP5Ao0YMzKxSBqDkKdkefY695gW0MpOZhv7hfFiWzcAPs4eQOZ4rLddvmGD8zbtL53LolMMdfg007tNmv0Dq";

/** Determine whether current mode is development */
export const isDevelopmentMode =
  process.env.REACT_APP_ENV === "development" ||
  (process.env.REACT_APP_API_BASE_URL &&
    process.env.REACT_APP_API_BASE_URL.includes("rootpointers.net")) ||
  (process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY &&
    process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY.startsWith("pk_test_"));

export const stripePublishableKey =
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY ||
  (isDevelopmentMode ? DEV_STRIPE_PUBLISHABLE_KEY : PROD_STRIPE_PUBLISHABLE_KEY);

/** --- Production Stripe Price IDs --- */
const prodStripePriceIds: Record<string, string> = {
  small: "price_1UGyc5Ro5rtjEMiw2qCYazpK",
  medium: "price_1UGz2pRo5rtjEMiw9bNX9GxM",
  "large-medium": "price_1UGzMMRo5rtjEMiwAih8DU2S",
  large: "price_1UGzlwRo5rtjEMiw8JyIPI3g",
};

const prodStripePriceIdsPrepay3Year: Record<string, string> = {
  small: "price_1UGyqZRo5rtjEMiwn9nsXsSJ",
  medium: "price_1UGzEhRo5rtjEMiwsIgEiALL",
  "large-medium": "price_1UGzg1Ro5rtjEMiwSX3ibCHb",
  large: "price_1UGzx3Ro5rtjEMiw20c8R1Mf",
};

const prodStripeMaintenancePriceIds: Record<string, string> = {
  small: "price_1UGyeuRo5rtjEMiwIau9Oyw5",
  medium: "price_1UGz4hRo5rtjEMiwYjPcDzMj",
  "large-medium": "price_1UGzNVRo5rtjEMiwClslSboS",
  large: "price_1UGzmuRo5rtjEMiweQHM4Hao",
};

const prodStripeMaintenancePriceIdsPrepay3Year: Record<string, string> = {
  small: "price_1UGyy3Ro5rtjEMiwI8XpabGw",
  medium: "price_1UGzH3Ro5rtjEMiwwps2DAVz",
  "large-medium": "price_1UGzhWRo5rtjEMiwtsdoecxc",
  large: "price_1UGzzKRo5rtjEMiwdEabBKeW",
};

const prodStripeSupportPriceIds: Record<string, string> = {
  small: "price_1UGyiARo5rtjEMiw1Jt0KNui",
  medium: "price_1UGz6gRo5rtjEMiwheX1z8f1",
  "large-medium": "price_1UGzOXRo5rtjEMiwJ5Dvh41t",
  large: "price_1UGzniRo5rtjEMiwssGUue1j",
};

const prodStripeSupportPriceIdsPrepay3Year: Record<string, string> = {
  small: "price_1UGyzuRo5rtjEMiw1SGebSgg",
  medium: "price_1UGzI3Ro5rtjEMiwHpe4bmC9",
  "large-medium": "price_1UGzj7Ro5rtjEMiwP9VpdoyC",
  large: "price_1UH00nRo5rtjEMiwMUlnNEM6",
};

/** --- Development Stripe Price IDs --- */
const devStripePriceIds: Record<string, string> = {
  small: "price_1T288GRojWIVDFbP4qiXDYNf",
  medium: "price_1T27reRojWIVDFbPUm31ursA",
  "large-medium": "price_1TWI3cRojWIVDFbPrkkog8Nv",
  large: "price_1TWZ02RojWIVDFbPYxqBhbnP",
};

const devStripePriceIdsPrepay3Year: Record<string, string> = {
  small: "price_1TRuA2RojWIVDFbPlltVuwCB",
  medium: "price_1TRtrtRojWIVDFbPtfHtFBZa",
  "large-medium": "price_1TWZ3bRojWIVDFbPp3jxOlhD",
  large: "price_1TWZ6ORojWIVDFbPFOWqQv5s",
};

const devStripeMaintenancePriceIds: Record<string, string> = {
  small: "price_1T289bRojWIVDFbPajTBxDhQ",
  medium: "price_1T27sdRojWIVDFbPiKTqaUjZ",
  "large-medium": "price_1TWYyuRojWIVDFbPtC3PNs8J",
  large: "price_1TWZ0eRojWIVDFbP4wDr5ZcO",
};

const devStripeMaintenancePriceIdsPrepay3Year: Record<string, string> = {
  small: "price_1TWHaWRojWIVDFbPVEjpYvlb",
  medium: "price_1TWHnHRojWIVDFbP6e2zu2IA",
  "large-medium": "price_1TWZ5hRojWIVDFbPxNBp1Zuo",
  large: "price_1TWZ7IRojWIVDFbPofGRpjJs",
};

const devStripeSupportPriceIds: Record<string, string> = {
  small: "price_1T28AFRojWIVDFbPbmiXab42",
  medium: "price_1T27tRRojWIVDFbP77qYXf8q",
  "large-medium": "price_1TWYzNRojWIVDFbPYg9uLBsL",
  large: "price_1TWZ1RRojWIVDFbPLYfToBil",
};

const devStripeSupportPriceIdsPrepay3Year: Record<string, string> = {
  small: "price_1TWHbgRojWIVDFbPYO2PtTSv",
  medium: "price_1TWHoZRojWIVDFbPLoaV2YpM",
  "large-medium": "price_1TWZ4nRojWIVDFbP3ndiuZyf",
  large: "price_1TWZ82RojWIVDFbPA4zp8wLZ",
};

/** Active Stripe Price IDs exported based on current environment */
export const stripePriceIds: Record<string, string> = isDevelopmentMode
  ? devStripePriceIds
  : prodStripePriceIds;

export const stripePriceIdsPrepay3Year: Record<string, string> = isDevelopmentMode
  ? devStripePriceIdsPrepay3Year
  : prodStripePriceIdsPrepay3Year;

export const stripeMaintenancePriceIds: Record<string, string> = isDevelopmentMode
  ? devStripeMaintenancePriceIds
  : prodStripeMaintenancePriceIds;

export const stripeMaintenancePriceIdsPrepay3Year: Record<string, string> = isDevelopmentMode
  ? devStripeMaintenancePriceIdsPrepay3Year
  : prodStripeMaintenancePriceIdsPrepay3Year;

export const stripeSupportPriceIds: Record<string, string> = isDevelopmentMode
  ? devStripeSupportPriceIds
  : prodStripeSupportPriceIds;

export const stripeSupportPriceIdsPrepay3Year: Record<string, string> = isDevelopmentMode
  ? devStripeSupportPriceIdsPrepay3Year
  : prodStripeSupportPriceIdsPrepay3Year;

/** Stripe Product IDs for reference */
export const stripeProductIds = {
  small: {
    monthly: "prod_VHXhxccXH9gWFN",
    monthlyMaintenance: "prod_VHXk7INvXWLNwR",
    monthlySupport: "prod_VHXnUU03WFO5My",
    prepay3Year: "prod_VHXw2TuJLLncIo",
    prepay3YearMaintenance: "prod_VHY4RD6N5GOgq5",
    prepay3YearSupport: "prod_VHY68z8uDxc4s6",
  },
  medium: {
    monthly: "prod_VHY9pctYkX4Ehp",
    monthlyMaintenance: "prod_VHYBXSgnGOnc5t",
    monthlySupport: "prod_VHYDBlntlaF89r",
    prepay3Year: "prod_VHYLMxLEiSqYZB",
    prepay3YearMaintenance: "prod_VHYNsFRyFYgTvM",
    prepay3YearSupport: "prod_VHYOZNVt08Dsdj",
  },
  "large-medium": {
    monthly: "prod_VHYT4XVUT7s6l4",
    monthlyMaintenance: "prod_VHYUZBqvfO4RjK",
    monthlySupport: "prod_VHYVg4DQl2RfSY",
    prepay3Year: "prod_VHYnxpnC5sOUlp",
    prepay3YearMaintenance: "prod_VHYpWzclcmNTcw",
    prepay3YearSupport: "prod_VHYqVsFm0aM7Iu",
  },
  large: {
    monthly: "prod_VHYtZbXDGYtpob",
    monthlyMaintenance: "prod_VHYumpMRSpJpx4",
    monthlySupport: "prod_VHYvmebh0Gs7iX",
    prepay3Year: "prod_VHZ5SfKpCzezYE",
    prepay3YearMaintenance: "prod_VHZ7EO8QUcovlT",
    prepay3YearSupport: "prod_VHZ9G50YDZgR8O",
  },
} as const;
